import React, { useState, useEffect } from 'react';
import style from './css/header.module.css';

import careerquest1 from '../../assets/career2020.JPG';
import careerquest2 from '../../assets/events/graduation2024 (15).JPG';
import careerquest3 from '../../assets/events/graduation2024 (7).JPG';

const slides = [
  {
    image: careerquest1,
    caption: "Left to Right: Mr Joseph Ebinum (Chairman PIIT), Mr Seetam (Aptech India), Ms. Neeha (Aptech India), Middlesex University Representative."
  },
  {
    image: careerquest2,
    caption: "Graduation 2024 - The Chairman PIIT, Executive Director (Mrs. Kate Ebinum), Student Governor and the General Manager of PIIT (Mr. Olusegun Adegbite)."
  },
  {
    image: careerquest3,
    caption: "Graduation Ceremony 2024 for ADSE Students going to Middlesex & Bolton University"
  },
];

const Header = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
    }, 5000); // Slide change every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className={style.headerImageContainer}>
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide.image}
            alt={`Slide ${index}`}
            className={`${style.headerImage} ${index === currentIndex ? style.active : ''}`}
          />
        ))}
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${style.caption} ${index === currentIndex ? style.activeCaption : ''}`}
          >
            {slide.caption}
          </div>
        ))}
      </div>

      <div className={style.aboutContainer}>
        <header className={style.aboutHeader}>
          <h2 className={style.aboutTitle}>About Aptech Lekki Centre</h2>
            <p className={style.aboutMainText}>
            Aptech Lekki Centre is a Franchise of Aptech Limited, a Global Learning Solutions Company with a presence across 5 continents, is playing a key role in helping individuals, organizations and nations adapt to the changing requirements of a knowledge-driven world. Aptech commenced its IT education & training business in 1986 and has trained over 7 million students globally.
            </p>
            <p className={style.aboutMainText}>
            Aptech is an ISO 9001:2000 organization and was the first IT training and education organization in Asia to receive the ISO 9001 quality certification for Education Support Services in 1993. We have been awarded with ISO27001 for our LEARNING SERVICES and ATTEST divisions and are CMMI Level 3 certified for content development.
            </p>
            <p className={style.aboutMainText}>
            As a pioneer and leader in the field of IT education, Aptech has amassed a rich experience of over 31 years in the field. The company develops and deploys learning solutions for its clientele ranging from young school children to working IT professionals to major Fortune 500 companies. Aptech offers a wide range of solutions across various segments.
            </p>
        </header>
      </div>
    </>
  );
};

export default Header;
